"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-75',
    connection_id: 'connection-69'
  },
  chain_2: {
    chain_name: 'archway',
    client_id: '07-tendermint-23',
    connection_id: 'connection-21'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-60',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-20',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-11',
    connection_id: 'connection-14'
  },
  chain_2: {
    chain_name: 'axelar',
    client_id: '07-tendermint-69',
    connection_id: 'connection-51'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-9',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-41',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-70',
    connection_id: 'connection-64'
  },
  chain_2: {
    chain_name: 'composable',
    client_id: '07-tendermint-51',
    connection_id: 'connection-20'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-55',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-13',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-6',
    connection_id: 'connection-8'
  },
  chain_2: {
    chain_name: 'cosmoshub',
    client_id: '07-tendermint-927',
    connection_id: 'connection-649'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-405',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-2',
    connection_id: 'connection-2'
  },
  chain_2: {
    chain_name: 'crescent',
    client_id: '07-tendermint-19',
    connection_id: 'connection-14'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-11',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-72',
    connection_id: 'connection-66'
  },
  chain_2: {
    chain_name: 'evmos',
    client_id: '07-tendermint-116',
    connection_id: 'connection-70'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-57',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-85',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-4',
    connection_id: 'connection-7'
  },
  chain_2: {
    chain_name: 'gravitybridge',
    client_id: '07-tendermint-173',
    connection_id: 'connection-154'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-4',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-91',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-20',
    connection_id: 'connection-20'
  },
  chain_2: {
    chain_name: 'kujira',
    client_id: '07-tendermint-94',
    connection_id: 'connection-64'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-13',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-61',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-77',
    connection_id: 'connection-72'
  },
  chain_2: {
    chain_name: 'noble',
    client_id: '07-tendermint-32',
    connection_id: 'connection-40'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-62',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-21',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-73',
    connection_id: 'connection-67'
  },
  chain_2: {
    chain_name: 'omniflixhub',
    client_id: '07-tendermint-47',
    connection_id: 'connection-40'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-58',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-30',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-1',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2109',
    connection_id: 'connection-1649'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-320',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-93',
    connection_id: 'connection-91'
  },
  chain_2: {
    chain_name: 'persistence',
    client_id: '07-tendermint-167',
    connection_id: 'connection-210'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-72',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-202',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-17',
    connection_id: 'connection-17'
  },
  chain_2: {
    chain_name: 'secretnetwork',
    client_id: '07-tendermint-111',
    connection_id: 'connection-80'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-10',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-51',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-74',
    connection_id: 'connection-68'
  },
  chain_2: {
    chain_name: 'stride',
    client_id: '07-tendermint-129',
    connection_id: 'connection-118'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-59',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-148',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'agoric',
    client_id: '07-tendermint-18',
    connection_id: 'connection-18'
  },
  chain_2: {
    chain_name: 'umee',
    client_id: '07-tendermint-152',
    connection_id: 'connection-101'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-11',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-42',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;